export const isMobile = () => {
    return ( ( window.innerWidth <= 800 ) && ( window.innerHeight <= 800 ) );
}

export const getSeoUrl = (name) =>{
    let seoName = name.toLowerCase().replaceAll(" ", "");
    seoName = seoName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    seoName = encodeURI(seoName);
    return seoName;
} 